import React from 'react'
import { useCheck } from '../context/useCheck'
import { ValidatedZones } from './ValidatedZones'

/*
 * Copyright 2022-07-28 por Jairo Espitia Ecomsur Holding S.A ©
 * Detalle: Componente de listado de zonas pendientes de OT
 */

interface DispatchZonesProps {}

export const DispatchZones: React.FC<DispatchZonesProps> = () => {
  const {
    state: { zonesStatus }
  } = useCheck()

  return <ValidatedZones zonesStatus={zonesStatus} />
}
